import { render, staticRenderFns } from "./AMPMSwitchInTitle.vue?vue&type=template&id=4206589a&"
import script from "./AMPMSwitchInTitle.vue?vue&type=script&lang=js&"
export * from "./AMPMSwitchInTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports